import React from 'react';
import { Link } from 'react-router-dom';

const Audiences = () => {
  return (
    <section className="border-y border-[#17211E]/10 bg-white py-24">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-[1.05fr_.95fr] lg:px-8">
        <div className="border border-[#17211E]/15 bg-[#FAF8F3] p-9 sm:p-14">
          <div className="mb-8 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
            Who you&apos;re working with
          </div>
          <div className="flex items-center gap-5 sm:gap-7">
            <div className="h-28 w-28 shrink-0 overflow-hidden rounded-full sm:h-32 sm:w-32">
              <img
                src="/dave-barrick.png?v=5"
                alt="Dave Barrick, founder of ManagedSite"
                className="h-full w-full object-cover"
              />
            </div>
            <h2 className="text-4xl leading-tight sm:text-5xl">
              Hi, I&apos;m Dave.
            </h2>
          </div>
          <p className="mt-8 text-lg leading-relaxed text-[#17211E]/75">
            I&apos;ve spent my career hosting, supporting, and fixing
            websites. Over the years, I kept seeing the same problem:
            businesses had a website, email, and hosting, but when
            something went wrong, they often didn&apos;t know who to
            turn to for help.
            <br /><br />
            I started ManagedSite to fill that gap, to give small
            businesses one dependable place to turn when they need help.
            <br /><br />
            We&apos;re a small, privately owned U.S. company, founded in
            Indiana in 1996.
            <br /><br />
            When you contact ManagedSite, you&apos;re talking to me, the
            person responsible for making sure the work gets done.
          </p>
          <div className="mt-10 border-t border-[#17211E]/15 pt-7">
            <p className="home-serif text-2xl italic text-[#174C3C]">
              No runaround. No bouncing between departments. Someone who
              takes responsibility for your site.
            </p>
            <Link to="/contact" className="home-link mt-7 inline-block">
              Talk to Dave
            </Link>
          </div>
        </div>

        <div className="bg-[#174C3C] p-9 text-white sm:p-14">
          <div className="mb-9 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
            For agencies
          </div>
          <h2 className="text-4xl leading-tight sm:text-5xl">
            Extra technical help behind your brand.
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-white/75">
            Add technical capacity without hiring internally. ManagedSite.net
            provides white-label website management, hosting, and support while
            you keep the client relationship.
          </p>
          <ul className="mt-10 space-y-4 border-t border-white/20 pt-8 text-lg text-white/85">
            <li>White-label WordPress management</li>
            <li>Agency technical support</li>
            <li>Reseller hosting and migrations</li>
            <li>Security, monitoring, and reporting</li>
          </ul>
          <Link
            to="/agency-services"
            className="mt-10 inline-block font-bold text-[#D7B77A] underline decoration-2 underline-offset-4"
          >
            See agency services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Audiences;
